<div class="auth-header">
  <div class="logo-container">
    <dk-seed-icon [attr.data-testid]="'auth-header-logo'"></dk-seed-icon>
    <span class="logo-text">Doktar</span>
  </div>
  <div class="language-selector">
    <p-select
      [options]="languages"
      [(ngModel)]="selectedLanguage"
      optionLabel="nativeName"
      (onChange)="onLanguageChange($event)">
    </p-select>
  </div>
</div>
